
let stuySubjectList = JSON.parse(localStorage.getItem('stuySubjectDict') || '[]')
let agentSubjectList = JSON.parse(localStorage.getItem('agentSubjectDict') || '[]')

export const agentSubjectDict = agentSubjectList

export const studySubjectDict = stuySubjectList